<div class="d-flex w-100 h-100" style="position:fixed;top:0px;left:0px;width:100%" (click)="onClick()">
    <div class="d-flex justify-content-center align-items-center lamp bg-danger mr-3" [ngClass]="{'bg-success': a1.value, 'bg-danger': !a1.value}">A1</div>
    <div class="d-flex justify-content-center align-items-center lamp bg-danger mr-3" [ngClass]="{'bg-success': a2.value, 'bg-danger': !a1.value}">A2</div>
    {{actual.value}} / {{setpoint.value}}
</div>